import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";
import { Machine } from "../../../../machines/shared/models/machine";
import { MachineConfiguration } from "../../../../machines/shared/models/machineConfiguration";

export class DepreciationDetailsViewController implements IOnInit {
  static $inject = ["environment", "$state",];

  depreciation!: any;
  machine!: Machine<MachineConfiguration>
  currentConfiguration!: MachineConfiguration

  constructor(private readonly environment: { Date: Date }, private readonly $state: StateService,) { }

  $onInit(): void {
    this.currentConfiguration = this.machine.Configs?.find(c => c.CurrentConfiguration)!
  }
  isCurrentYear(detail: { StartDate?: Date; EndDate?: Date }): boolean {
    const startDate = detail.StartDate ?? this.depreciation.UsefulLifeStartDate;
    const endDate = detail.EndDate ?? this.depreciation.UsefulLifeEndDate;
    return (
      startDate <= this.environment.Date && endDate > this.environment.Date
    );
  }
  getDepreciationMethod(method: string) {
    switch (method) {
      case "StraightLine":
        return "Straight Line";
      case "DoubleDecliningBalance":
        return "Double Declining Balance";
      case "SumOfTheYearsDigits":
        return "Sum Of The Years Digits";
      default:
        return "";
    }
  }
  async NavigateToDetails() {
    await this.$state.go("main.machines.detail.Depreciation", { "machineId": this.machine.Id }, { reload: true });
  }
}
